var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgELogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "421px",
    height: "454px",
    viewBox: "0 0 421 454",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    className: "fil0",
    d: "M196 452c124,0 225,-101 225,-225 0,-61 -24,-117 -64,-158 17,36 26,77 26,120 0,139 -100,252 -225,252 -3,0 -6,0 -9,0 120,-5 216,-116 216,-252 0,-56 -16,-107 -43,-149 -36,-24 -79,-38 -126,-38 -28,0 -54,5 -78,14l0 0c54,0 98,18 133,55 34,37 51,89 51,155 0,4 0,10 0,19l-302 0c3,44 15,78 38,102 22,23 50,35 84,35 25,0 47,-7 64,-20 18,-13 32,-34 43,-64l72 0c0,3 -1,7 -1,10 -11,41 -32,73 -62,96 -30,23 -69,34 -116,34 -1,0 -3,0 -4,0 24,9 50,14 78,14zm-192 -264l225 0c-3,-34 -11,-59 -25,-76 -22,-27 -51,-40 -85,-40 -32,0 -58,11 -80,32 -21,21 -33,49 -35,84z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgELogoWhite);
export default __webpack_public_path__ + "static/media/e-logo-white.6debefb865ebfb41f7a86381edc270e8.svg";
export { ForwardRef as ReactComponent };